import { render, staticRenderFns } from "./RTabForPC.vue?vue&type=template&id=2b990cc6&scoped=true"
import script from "./RTabForPC.vue?vue&type=script&lang=js"
export * from "./RTabForPC.vue?vue&type=script&lang=js"
import style0 from "./RTabForPC.vue?vue&type=style&index=0&id=2b990cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b990cc6",
  null
  
)

export default component.exports